export default __webpack_public_path__ + "static/media/hhs-qld-wide-bay.3c7b1565.svg";